import { FC } from 'react';

import { SvgIcon, SvgIconProps } from '@thirdspacelearning/library';

interface Props extends SvgIconProps {}

const DialogBadgeLocked: FC<Props> = ({ ...props }) => (
    <SvgIcon
        width="172"
        height="168"
        viewBox="0 0 172 168"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="dialog-badge-locked"
        {...props}
    >
        <path
            d="M89.9394 53.8818L85.0294 53.4505C83.8019 53.3509 54.8562 50.7135 43.4604 39.3343C28.6475 24.5214 39.8443 13.3412 44.6215 8.56394C49.3988 3.78666 60.579 -7.3935 75.3919 7.4028C86.7711 18.782 89.4085 47.7443 89.5081 48.9718L89.9394 53.8818ZM60.6453 8.29854C57.3941 8.29854 54.3254 10.5711 50.4936 14.4194C43.5102 21.4029 41.6855 25.8152 49.3325 33.4622C55.6524 39.7821 71.162 43.1992 80.6502 44.576C79.2734 35.1044 75.8563 19.5948 69.5364 13.2583C66.0861 9.80802 63.2994 8.28195 60.6453 8.28195V8.29854Z"
            fill="#EDF0FF"
        />
        <path
            d="M83.7529 53.8817L84.1842 48.9718C84.2837 47.7443 86.9212 18.7986 98.3004 7.40278C113.113 -7.41011 124.293 3.78664 129.071 8.56392C133.848 13.3412 145.028 24.5214 130.232 39.3343C118.853 50.7135 89.8904 53.3509 88.6629 53.4505L83.7529 53.8817ZM104.172 13.2749C97.8525 19.5948 94.4355 35.121 93.0587 44.5926C102.53 43.2158 118.04 39.7987 124.376 33.4788C132.023 25.8152 130.199 21.4195 123.215 14.436C116.232 7.45254 111.819 5.62789 104.172 13.2749Z"
            fill="#EDF0FF"
        />
        <path
            d="M86.9193 54.4792C93.1672 54.4792 98.2322 49.4143 98.2322 43.1664C98.2322 36.9185 93.1672 31.8535 86.9193 31.8535C80.6714 31.8535 75.6064 36.9185 75.6064 43.1664C75.6064 49.4143 80.6714 54.4792 86.9193 54.4792Z"
            fill="#EDF0FF"
        />
        <path
            d="M166.014 62.6348H6.17773V163.012C6.17773 165.572 8.25312 167.648 10.8132 167.648H161.378C163.938 167.648 166.014 165.572 166.014 163.012V62.6348Z"
            fill="#EDF0FF"
        />
        <path
            d="M169.1 43.165H2.31776C1.0377 43.165 0 44.2027 0 45.4828V66.4256C0 67.7057 1.0377 68.7434 2.31777 68.7434H169.1C170.38 68.7434 171.418 67.7057 171.418 66.4256V45.4828C171.418 44.2027 170.38 43.165 169.1 43.165Z"
            fill="#EDF0FF"
        />
        <rect
            x="65.5698"
            y="103.895"
            width="41.1478"
            height="33.1639"
            fill="#8F411C"
        />
        <path
            d="M106.418 94.9981V74.5741C106.418 63.2943 97.2737 54.1501 85.9938 54.1501V54.1501C74.714 54.1501 65.5698 63.2943 65.5698 74.5741V94.9981"
            stroke="#A5ACB6"
            strokeWidth="7.51959"
            fill="#EDF0FF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M47.875 86.6188C47.875 83.8346 50.132 81.5776 52.9162 81.5776H118.988C121.772 81.5776 124.029 83.8346 124.029 86.6188V152.691C124.029 155.475 121.772 157.732 118.988 157.732H52.9162C50.132 157.732 47.875 155.475 47.875 152.691V86.6188ZM89.3492 120.813C92.1195 119.528 94.0409 116.723 94.0409 113.468C94.0409 108.999 90.4183 105.377 85.9495 105.377C81.4808 105.377 77.8582 108.999 77.8582 113.468C77.8582 116.63 79.672 119.369 82.3159 120.7L81.539 132.742C81.5029 133.302 81.9473 133.776 82.5084 133.776H89.5337C90.1072 133.776 90.5559 133.282 90.5006 132.711L89.3492 120.813Z"
            fill="#FFA726"
        />
    </SvgIcon>
);

export default DialogBadgeLocked;
